export default __webpack_public_path__ + "1d6f94f44950eccbf2859c21b3ed5fbb.svg";